import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { CoreService } from '@portal-output/core/services/core.service';
import { map } from 'rxjs';

export const siteGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const coreService = inject(CoreService);

  const siteKey = route.params.siteKey;

  return coreService.setSiteKey$(siteKey).pipe(
    map(() => true)
  );
};
